import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../theme';

export default function HeroSearch() {
  const { p, d, fonts } = useTheme();
  const [q, setQ] = useState('');
  const [online, setOnline] = useState(34);
  const navigate = useNavigate();

  useEffect(() => {
    const id = setInterval(() => {
      setOnline(prev => Math.max(12, prev + Math.floor(Math.random() * 9) - 4));
    }, 15000 + Math.random() * 15000);
    return () => clearInterval(id);
  }, []);

  const handleSearch = () => {
    if (q.trim()) navigate(`/search-tags?q=${encodeURIComponent(q.trim())}`);
    else navigate('/search-tags');
  };

  return (
    <div style={{
      width: '100%',
      padding: `${d.hero}px ${d.pad}px ${d.hero * 0.7}px`,
      borderBottom: `1px solid ${p.border}`,
      position: 'relative',
    }}>
      <div aria-hidden style={{
        position: 'absolute', inset: 0,
        backgroundImage: `linear-gradient(${p.borderHi} 1px, transparent 1px), linear-gradient(90deg, ${p.borderHi} 1px, transparent 1px)`,
        backgroundSize: '72px 72px',
        opacity: .18, pointerEvents: 'none',
        maskImage: 'radial-gradient(ellipse at 50% 30%, black 30%, transparent 75%)',
        WebkitMaskImage: 'radial-gradient(ellipse at 50% 30%, black 30%, transparent 75%)',
      }} />

      <div style={{ maxWidth: 1180, margin: '0 auto', position: 'relative' }}>
        <div style={{
          fontFamily: fonts.mono, fontSize: 11, color: p.textDim,
          letterSpacing: '.18em', textTransform: 'uppercase',
          display: 'flex', justifyContent: 'space-between', marginBottom: 48,
        }}>
          <span><span className="hero-live-dot" style={{ color: p.accent }}>●</span>&nbsp;&nbsp;index live&nbsp;&nbsp;·&nbsp;&nbsp;{online.toLocaleString()} searching now</span>
          <span>archival index</span>
        </div>

        <h1 style={{
          fontFamily: fonts.serif, fontSize: d.hero, fontWeight: 400,
          letterSpacing: '-.035em', lineHeight: .96, margin: '0 0 24px',
          color: p.textHi, maxWidth: 1100,
        }}>
          A searchable archive<br />
          <span style={{ fontStyle: 'italic', color: p.text }}>of the people you</span><br />
          <span style={{ color: p.accent, fontStyle: 'italic' }}>used to play with.</span>
        </h1>

        <p style={{
          fontFamily: fonts.sans, fontSize: d.body + 2, lineHeight: 1.55, color: p.text,
          margin: '0 0 56px', maxWidth: 680,
        }}>
          Type a username you used to use on Xbox, PlayStation, Steam, or Discord.
          If anyone has filed a note for that handle, whether it's an old teammate, a guild member,
          or a friend you lost touch with, UserTags will surface it.
        </p>

        <div style={{ maxWidth: 780 }}>
          <div style={{
            display: 'flex', alignItems: 'center', gap: 14,
            padding: '4px 4px 4px 24px',
            background: p.bgPanel,
            border: `1px solid ${p.borderHi}`,
          }}>
            <span style={{ color: p.accent, fontFamily: fonts.mono, fontSize: 18, fontWeight: 500, userSelect: 'none' }}>›</span>
            <input
              value={q}
              onChange={e => setQ(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSearch()}
              placeholder="search by exact username, case insensitive"
              style={{
                flex: 1, background: 'transparent', border: 'none', outline: 'none',
                color: p.textHi, fontSize: 18, padding: '18px 0',
                fontFamily: fonts.mono, fontWeight: 400, letterSpacing: '-.005em',
                caretColor: p.accent,
              }}
            />
            <span
              onClick={handleSearch}
              style={{
                padding: '14px 22px', background: p.accent, color: p.bg,
                fontFamily: fonts.mono, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                letterSpacing: '.04em',
              }}
            >SEARCH ↵</span>
          </div>

          <div style={{ marginTop: 14, fontFamily: fonts.mono, fontSize: 12, color: p.textDim, letterSpacing: '.02em' }}>
            try: <span style={{ color: p.text, cursor: 'pointer' }}>kestrel_99</span> · <span style={{ color: p.text, cursor: 'pointer' }}>murph#0091</span> · <span style={{ color: p.text, cursor: 'pointer' }}>BigFootTommy</span>
          </div>
        </div>

        <div style={{ marginTop: 64 }}>
          <PlainStrip p={p} fonts={fonts} />
        </div>
      </div>

      <style>{`
        @keyframes heroPulse { 0%,100% { opacity: 1; } 50% { opacity: 0.35; } }
        .hero-live-dot { animation: heroPulse 2.5s ease-in-out infinite; }
      `}</style>
    </div>
  );
}

function PlainStrip({ p, fonts }) {
  const items = [
    { k: 'opt_in', v: 'tags only appear when both sides search' },
    { k: 'erasure', v: 'one click to remove yourself, no login' },
    { k: 'no_resale', v: 'never sold, never syndicated, never scraped' },
  ];
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 0,
      borderTop: `1px solid ${p.border}`, borderBottom: `1px solid ${p.border}`,
    }}>
      {items.map((it, i) => (
        <div key={it.k} style={{
          padding: '18px 24px',
          borderRight: i < 2 ? `1px solid ${p.border}` : 'none',
          fontFamily: fonts.mono, fontSize: 12.5,
        }}>
          <div style={{ color: p.accent, fontSize: 11, letterSpacing: '.08em', marginBottom: 4 }}>{it.k.toUpperCase()}</div>
          <div style={{ color: p.text }}>{it.v}</div>
        </div>
      ))}
    </div>
  );
}
